import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appFormatCard]'
})
export class FormatCardDirective {

  constructor(private ele: ElementRef) { }

  @HostListener('keypress', ['$event'])
  formatKeypress(event) {
    // only allow digits to be typed in
    if (event.which < 48 || event.which > 57) {
      event.preventDefault();
    } else {
      this.ele.nativeElement.value = this.ele.nativeElement.value.replace(/\D/g, '').replace(/(.{4})/g, '$1 ');
    }
  };
}
